import { Dropdown, DropdownButton, DropdownBody } from "@components";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { cn } from "@utils";

const inlineBtn =
  "inline-flex items-center gap-1 h-8 text-sm font-semibold text-zinc-500 cursor-pointer hover:text-primary";

const pillBase =
  "inline-flex items-center gap-1 h-8 text-xs font-semibold rounded-full px-4 select-none transition-colors";
const pillDisabled = "text-zinc-600 bg-zinc-100 border border-zinc-200";
const pillNormal =
  "text-zinc-600 bg-white border border-zinc-200 hover:bg-zinc-50";
const pillEdited =
  "text-blue-800 bg-blue-50 border border-blue-200 hover:bg-blue-100";
const pillEditedDisabled = "text-blue-800 bg-blue-50 border border-blue-200";

export default function EditorDropdown({
  label,
  variant = "inline",
  edited = false,
  disabled = false,
  bodyClassName = "min-w-48",
  children,
}) {
  const isPill = variant === "pill";

  const pillStyle = disabled
    ? edited
      ? pillEditedDisabled
      : pillDisabled
    : edited
      ? pillEdited
      : pillNormal;

  if (disabled) {
    return (
      <div
        className={
          isPill
            ? cn(pillBase, "cursor-default", pillStyle)
            : cn(inlineBtn, "cursor-default")
        }
      >
        <span>{label}</span>
      </div>
    );
  }

  return (
    <Dropdown>
      {() => (
        <>
          <DropdownButton
            className={
              isPill ? cn(pillBase, "cursor-pointer", pillStyle) : inlineBtn
            }
          >
            <span>{label}</span>
            <ChevronDownIcon
              className={isPill ? "w-3.5 h-3.5" : "w-4 h-4 text-zinc-500"}
            />
          </DropdownButton>

          <DropdownBody className={bodyClassName}>{children}</DropdownBody>
        </>
      )}
    </Dropdown>
  );
}
